import "../../../styles/index.css"
import "./ModalNotificar.css"
import CustomButton from "../../Buttons/CustomButton/CustomButton"
import MinusIcon from "../../../assets/icons/Minus Icon 2.svg"
import PlusIcon from "../../../assets/icons/Plus Icon 2.svg"
import EmailIcon from "../../../assets/icons/Email Icon.svg"
import { formataPreço } from "../../../utils/preços"
import { useState, useEffect } from "react"
import $ from "jquery"
import { apiUser } from "../../../api/api"
import { categoryFromDatabase } from "../../../utils/categoryFromDatabase"
import OneSignal from "react-onesignal"

function ModalNotificar({ preçoAtual, categoria, productID }) {
	const [preçoDesejado, setPreçoDesejado] = useState("")

	useEffect(() => {
		setPreçoDesejado(preçoAtual.toString())
	}, [preçoAtual])

	const onClickSoma = (event) => {
		console.log(preçoDesejado)
		setPreçoDesejado((parseFloat(preçoDesejado) + 100).toFixed(2).toString())
	}

	const onClickSubtrai = (event) => {
		console.log(preçoDesejado)

		if (preçoDesejado - 100 > 0) {
			setPreçoDesejado((parseFloat(preçoDesejado) - 100).toFixed(2).toString())
		}
	}

	const onClickAlertarEmail = (event) => {
		event.preventDefault()

		const category = categoryFromDatabase[categoria] ? categoryFromDatabase[categoria] : "Pesquisa"

		const email = $(".inputEmailNotify").val()

		apiUser.criaNotificacaoEmail(email, preçoDesejado, category, productID).then((response) => {
			console.log(response)
		})

		$("#botaoFecharModalNotificar").click()
	}

	const onClickAlertarNavegador = (event) => {
		event.preventDefault()

		const category = categoryFromDatabase[categoria] ? categoryFromDatabase[categoria] : "Pesquisa"

		OneSignal.init({
			appId: process.env.REACT_APP_ONE_SIGNAL_APP_ID,
		}).then(() => {
			OneSignal.showNativePrompt().then(() => {
				OneSignal.registerForPushNotifications()

				OneSignal.getUserId().then((userId) => {
					if (userId) {
						apiUser.criaNotificacaoNavegador(userId, preçoDesejado, category, productID).then((response) => {
							console.log(response)
						})
					}
				})
			})
		})

		$("#botaoFecharModalNotificar").click()
	}

	return (
		<div className="modal fade" id="modalNotificar" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="modal-header">
						<h1 className="modal-title fs-5" id="exampleModalLabel">
							Criar Alerta de Preço
						</h1>
						<button type="button" id="botaoFecharModalNotificar" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div className="modal-body corpoModalNotificar">
						<p className="b2">Defina um preço que deseja comprar esse produto e avisaremos você assim que ele atingir este valor.</p>

						<section className="secaoValorDesejado">
							<p className="bt1">Preço Desejado:</p>

							<div className="divValorDesejado">
								<button onClick={onClickSubtrai}>
									<img src={MinusIcon} alt="Minus Icon" />
								</button>

								<input readOnly type="text" className="inputPreçoDesejado" value={`R$ ${formataPreço(preçoDesejado.replace(".", ","))}`} />

								<button onClick={onClickSoma}>
									<img src={PlusIcon} alt="Plus Icon" />
								</button>
							</div>
						</section>

						<form onSubmit={onClickAlertarEmail}>
							<section className="secaoNotificarEmail">
								<p className="bt1">Seja notificado por email</p>

								<div className="divNotificarEmail">
									<img src={EmailIcon} alt="" />

									<input type="email" className="inputEmailNotify" placeholder="email@example.com" required />
								</div>

								<div className="d-flex justify-content-center">
									<CustomButton type="submit" texto="Alertar por Email" cor="#A80A01" tipo='1' />
								</div>
							</section>
						</form>

						<section className="secaoNotificarNavegador">
							<p className="bt1">Deixe o navegador notificar você</p>

							<div className="divNotificarNavegador">
								<CustomButton texto="Alertar por navegador" cor="white" tipo='1' onClick={onClickAlertarNavegador} />
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ModalNotificar
